import VueYandexMetrika from 'vue-yandex-metrika';

const yandexMetrikaParams = {
  env: import.meta.env.MODE,
  id: 91528504,
  options: {
    accurateTrackBounce: true,
    clickmap: true,
    trackLinks: true,
    webvisor: false,
  },
};

/**
 * @description Идентификатор цели успешной регистрации.
 * @type {string}
 */
export const GOAL_COMPLETED_REGISTRATION = 'onCompletedRegistration';

/**
 * @description Идентификатор цели "Клик по кнопке Онлайн".
 * @type {string}
 */
export const GOAL_COMPLETED_CLICK_ONLINE_BUTTON = 'onCompletedClickOnlineButton';

/**
 * @description Идентификатор цели "Клик на кнопку скачать счет".
 * @type {string}
 */
export const GOAL_COMPLETED_CLICK_DOWNLOAD_INVOICE = 'onClickDownloadInvoice';

/**
 * @description Идентификатор цели смены шага сетки в расписании.
 * @type {string}
 */
export const GOAL_CHANGE_APPOINTMENT_TIMELINE_STEP = 'onChangeAppointmentTimelineStep';

/**
 * @description Идентификатор цели изменения фильтра по дате рождения пациента.
 * @type {string}
 */
export const GOAL_CHANGE_PATIENT_BIRTH_DATE_FILTER = 'onChangePatientBirthDateFilter';

/**
 * @description Идентификатор цели изменения месяца даты рождения пациента.
 * @type {string}
 */
export const GOAL_CHANGE_PATIENT_BIRTH_DATE_MONTH_FILTER = 'onChangePatientBirthDateMonthFilter';

/**
 * @description Идентификатор цели загрузки списка всех пациентов.
 * @type {string}
 */
export const GOAL_DOWNLOAD_PATIENTS_LIST = 'onDownloadPatientsList';

/**
 * @description Идентификатор цели просмотра обновлений приложения.
 * @type {string}
 */
export const GOAL_VIEW_UPDATES_APP = 'onViewUpdatesApp';

/**
 * @description Идентификатор цели нажатия кнопки помощи.
 * @type {string}
 */
export const GOAL_CLICK_HELP_BUTTON = 'onClickHelpButton';

/**
 * @description Идентификатор цели нажатия на ФИО доктора в расписании.
 * @type {string}
 */
export const GOAL_CLICK_DOCTOR_FIO_ON_SCHEDULE = 'onClickDoctorFioOnSchedule';

/**
 * @description Идентификатор цели нажатия на кнопку "Как настроить".
 * @type {string}
 */
export const GOAL_CLICK_HOW_TO_SET_UP_BUTTON = 'onClickHowToSetUpButton';

/**
 * @description Идентификатор цели переноса графика работы сотрудников на след. месяц.
 * @type {string}
 */
export const GOAL_COPY_EMPLOYEES_WORK_SCHEDULE = 'onCopyEmployeesWorkSchedule';

/**
 * @description Идентификатор цели печати медкарты в формате А5.
 * @type {string}
 */
export const GOAL_PRINT_MEDCART_A5 = 'onPrintMedcardA5';

/**
 * @description Идентификатор цели переключения детальной зубной формулы.
 * @type {string}
 */
export const GOAL_SWITCH_DETAIL_DENTAL_FORMULA = 'onSwitchDetailDentalFormula';

/**
 * @description Идентификатор цели применения шаблона в протокол приема.
 * @type {string}
 */
export const GOAL_APPLY_DIARY_TEMPLATE = 'onApplyDiaryTemplate';

/**
 * @description Идентификатор цели добавления счета.
 * @type {string}
 */
export const GOAL_ADD_INVOICE = 'onAddInvoice';

/**
 * @description Идентификатор цели применения шаблона плана лечения.
 * @type {string}
 */
export const GOAL_APPLY_TREATMENT_PLAN_TEMPLATE = 'onApplyTreatmentPlanTemplate';

/**
 * @description Идентификатор цели печати протокола.
 * @type {string}
 */
export const GOAL_PRINT_DOCUMENT_PROTOCOL = 'onPrintDocumentProtocol';

/**
 * @description Идентификатор цели скачивания протокола.
 * @type {string}
 */
export const GOAL_DOWNLOAD_DOCUMENT_PROTOCOL = 'onDownloadDocumentProtocol';

/**
 * @description Идентификатор цели выбор зуба в протоколе приема.
 * @type {string}
 */
export const GOAL_SELECT_TEETH_DIARY = 'onSelectTeethDiary';

/**
 * @description Идентификатор цели добавления услуги из плана лечения.
 * @type {string}
 */
export const GOAL_ADDING_TREATMENT_PLAN_SERVICE = 'onAddingTreatmentPlanService';

/**
 * @description Идентификатор цели клика по кнопке свободный врач.
 * @type {string}
 */
export const GOAL_CLICK_BUTTON_FREE_DOCTOR = 'onСlickButtonFreeDoctor';

/**
 * @description Идентификатор цели учёта времени.
 * @type {string}
 */
export const GOAL_ACCOUNTING_TIME = 'onAccountingTime';

/**
 * @description Идентификатор цели, успешное добавлении пациента через кнопку "Добавить запись".
 * @type {string}
 */
export const GOAL_SUCCESS_ADD_PATIENT_WAITING_LIST = 'onSuccessAddPatientWaitingList';

/**
 * @description Идентификатор цели, просмотра списка листа ожидания.
 * @type {string}
 */
export const GOAL_VIEW_WAITING_LIST = 'onSuccessViewWaitingList';

/**
 * @description Идентификатор цели, клик по кнопке обзвон.
 * @type {string}
 */
export const GOAL_CLICK_NEAREST_UNCONFIRMED_APPOINTMENT = 'onClickNearestUnconfirmedAppointment';

/**
 * @description Идентификатор цели, клик по кнопке сегодня.
 * @type {string}
 */
export const GOAL_CLICK_TODAY = 'onClickToday';

/**
 * @description Идентификатор цели, клик по кнопке завтра.
 * @type {string}
 */
export const GOAL_CLICK_TOMORROW = 'onClickTomorrow';

/**
 * @description Идентификатор цели, копировать визит.
 * @type {string}
 */
export const GOAL_COPY_APPOINTMENT = 'onCopyAppointment';

/**
 * @description Идентификатор цели, клик по кнопке "Мой профиль".
 * @type {string}
 */
export const GOAL_CLICK_MY_PROFILE = 'onClickMyProfile';

/**
 * @description Идентификатор цели, копировать пациента.
 * @type {string}
 */
export const GOAL_COPY_PATIENT = 'onCopyPatient';

/**
 * @description Идентификатор цели, клик по кнопке "Новый пациент" + сохранить.
 * @type {string}
 */
export const GOAL_CREATE_NEW_PATIENT = 'onClickNewPatient';

/**
 * @description Идентификатор цели, клик по настройкам колонок.
 * @type {string}
 */
export const GOAL_CHANGE_PATIENT_COLUMN_SETTINGS = 'onClickColumnSettings';

/**
 * @description Идентификатор цели, клика по дате визита пациента.
 * @type {string}
 */
export const GOAL_CLICK_PATIENT_VISIT_DATE = 'onClickPatientVisitDate';

/**
 * @description Идентификатор цели, скачать пациента.
 * @type {string}
 */
export const GOAL_DOWNLOAD_PATIENT = 'onDownloadPatient';

/**
 * @description Идентификатор цели, добавление метки.
 * @type {string}
 */
export const GOAL_ADD_PATIENT_LABELS = 'onAddPatientLabels';

/**
 * @description Идентификатор цели, добавление второго номера телефона.
 * @type {string}
 */
export const GOAL_ADD_SECOND_PATIENT_PHONE = 'onAddSecondPatientPhone';

/**
 * @description Идентификатор цели, сделать основным номером.
 * @type {string}
 */
export const GOAL_MAKE_MAIN_PATIENT_PHONE = 'onMakeMainPatientPhone';

/**
 * @description Идентификатор цели, клик по кнопке "Не звонить".
 * @type {string}
 */
export const GOAL_CLICK_DO_NOT_CALL = 'onDoNotCall';

/**
 * @description Идентификатор цели, добавить вопрос.
 * @type {string}
 */
export const GOAL_ADD_HEALTH_QUESTIONNAIRE_QUESTIONS = 'onAddHealthQuestionnaireQuestion';

/**
 * @description Идентификатор цели, печать.
 * @type {string}
 */
export const GOAL_PRINT_HEALTH_QUESTIONNAIRE_QUESTIONS = 'onPrintHealthQuestionnaireQuestion';

/**
 * @description Идентификатор цели, при клике пол любому фильтру.
 * @type {string}
 */
export const GOAL_CLICK_FILTER_PATIENT_PLAN = 'onClickFilterPatientPlan';

/**
 * @description Идентификатор цели, создать план лечения.
 * @type {string}
 */
export const GOAL_CREATE_PATIENT_PLAN = 'onCreatePatientPlan';

/**
 * @description Идентификатор цели, при клике по любому периоду или установке своей даты.
 * @type {string}
 */
export const GOAL_CHANGE_VALIDITY_PERIOD_PATIENT_PLAN = 'onValidatePeriodPatientPlan';

/**
 * @description Идентификатор цели, изменении по-ответственному.
 * @type {string}
 */
export const GOAL_CHANGE_RESPONSIBLE_PATIENT_PLAN = 'onChangeResponsiblePatientPlan';

/**
 * @description Идентификатор цели, применить по шаблону.
 * @type {string}
 */
export const GOAL_APPLY_TEMPLATE_PATIENT_PLAN = 'onApplyTemplatePatientPlan';

/**
 * @description Идентификатор цели, добавить этап.
 * @type {string}
 */
export const GOAL_ADD_STAGE_PATIENT_PLAN = 'onAddStagePatientPlan';

/**
 * @description Идентификатор цели, печать плана.
 * @type {string}
 */
export const GOAL_PRINT_PATIENT_PLAN = 'onPrintPatientPlan';

/**
 * @description Идентификатор цели, скачать план.
 * @type {string}
 */
export const GOAL_DOWNLOAD_PATIENT_PLAN = 'onDownloadPatientPlan';

/**
 * @description Идентификатор цели, запись на прием в истории посещений.
 * @type {string}
 */
export const GOAL_ADD_APPOINTMENT_PATIENT_APPOINTMENTS = 'onAddAppointmentPatientAppointments';

/**
 * @description Идентификатор цели, загрузка снимка.
 * @type {string}
 */
export const GOAL_UPLOAD_PATIENT_SNAPSHOTS = 'onUploadPatientSnapshot';

/**
 * @description Идентификатор цели, добавить документ.
 * @type {string}
 */
export const GOAL_ADD_DOCUMENT_PATIENT_DOCUMENTS = 'onAddDocumentPatientDocuments';

/**
 * @description Идентификатор цели, справка для налоговой в текстовом виде.
 * @type {string}
 */
export const GOAL_CLICK_DOCUMENT_REFERENCE_TEXT_TAX_PATIENT_DOCUMENTS = 'onClickDocumentReferenceTextTaxPatientDocuments';

/**
 * @description Идентификатор цели, справка для налоговой в электронном виде.
 * @type {string}
 */
export const GOAL_CLICK_DOCUMENT_REFERENCE_ELECTRON_TAX_PATIENT_DOCUMENTS = 'onClickDocumentReferenceElectronTaxPatientDocuments';

/**
 * @description Идентификатор цели, клик по реестру справок.
 * @type {string}
 */
export const GOAL_CLICK_REGISTRY_REFERENCES_PATIENT_DOCUMENTS = 'onClickRegistrationReferencesPatientDocuments';

/**
 * @description Идентификатор цели, поиск по документам.
 * @type {string}
 */
export const GOAL_SEARCH_BY_DOCUMENTS_PATIENT_DOCUMENTS = 'onSearchByDocumentsPatientDocuments';

/**
 * @description Идентификатор цели, пополнили аванс.
 * @type {string}
 */
export const GOAL_TOP_UP_ADVANCE_PATIENT_INVOICES = 'onTopUpAdvancePatientInvoice';

/**
 * @description Идентификатор цели, списали аванс.
 * @type {string}
 */
export const GOAL_WRITE_OFF_ADVANCE_PATIENT_INVOICES = 'onWriteOffAdvancePatientInvoice';

/**
 * @description Идентификатор цели, детализация аванса.
 * @type {string}
 */
export const GOAL_CLICK_PATIENT_DETAILING_ADVANCE_PATIENT_INVOICES = 'onDetailingAdvancePatientInvoice';

/**
 * @description Идентификатор цели, печать акта взаиморасчётов.
 * @type {string}
 */
export const GOAL_PRINT_ACT_MUTUAL_SETTLEMENTS_PATIENT_INVOICES = 'onPrintActMutualSettlementsPatientInvoice';

/**
 * @description Идентификатор цели, фильтровать счета.
 * @type {string}
 */
export const GOAL_FILTERS_PATIENT_INVOICE = 'onFiltersPatientInvoice';

/**
 * @description Идентификатор цели, ввод комментария.
 * @type {string}
 */
export const GOAL_INPUT_COMMENT_PATIENT_INVOICE = 'onInputCommentPatientInvoice';

/**
 * @description Идентификатор цели, изменение настройки таблицы.
 * @type {string}
 */
export const GOAL_CHANGE_SETTING_TABLE_PATIENT_INVOICE = 'onSettingTablePatientInvoice';

/**
 * @description Идентификатор цели, ввод рекламации в таблице услуг визита пациента.
 * @type {string}
 */
export const GOAL_INPUT_COMPLAINT_VISIT_SERVICE_TABLE = 'onInputComplaintVisitServiceTable';

/**
 * @description Идентификатор цели, печать акта по счету.
 * @type {string}
 */
export const GOAL_PRINT_ACT_INVOICE_ACT_PATIENT_INVOICE = 'onActByInvoicePatientInvoice';

/**
 * @description Идентификатор цели, переход к визиту.
 * @type {string}
 */
export const GOAL_TO_VISIT_PATIENT_INVOICE = 'onToVisitPatientInvoice';

/**
 * @description Идентификатор цели, выбор кассы.
 * @type {string}
 */
export const GOAL_SELECT_CASH_PATIENT_INVOICE = 'onSelectCashPatientInvoice';

/**
 * @description Идентификатор цели, клик по смешанной оплате.
 * @type {string}
 */
export const GOAL_CLICK_MULTI_PAY_PATIENT_INVOICE = 'onClickMultiPayPatientInvoice';

/**
 * @description Идентификатор цели, изменить способ оплаты.
 * @type {string}
 */
export const GOAL_CHANGE_PAY_MODE_PATIENT_INVOICE = 'onChangePayModePatientInvoice';

/**
 * @description Идентификатор цели, печать квитанции счета.
 * @type {string}
 */
export const GOAL_PRINT_INVOICE_RECEIPTS_PATIENT_INVOICE = 'onPrintInvoiceReceiptsPatientInvoice';

/**
 * @description Идентификатор цели, переход в любой другой визит.
 * @type {string}
 */
export const GOAL_TO_ANOTHER_VISIT_PATIENT_VISITS = 'onToAnotherVisitPatientVisits';

/**
 * @description Идентификатор цели, сохранить протокол как шаблон.
 * @type {string}
 */
export const GOAL_SAVE_PROTOCOL_AS_TEMPLATE_PATIENT_VISITS = 'onSaveProtocolAsTemplatePatientVisits';

/**
 * @description Идентификатор цели, прикрепить файл.
 * @type {string}
 */
export const GOAL_ATTACH_FILE_PATIENT_VISITS = 'onAttachFilePatientVisits';

/**
 * @description Идентификатор цели, перейти к счету.
 * @type {string}
 */
export const GOAL_TO_INVOICE_PATIENT_VISITS = 'onToInvoicePatientVisits';

/**
 * @description Идентификатор цели, выбор зуба при добавлении услуг из прайса.
 * @type {string}
 */
export const GOAL_SELECT_TOOTH_PATIENT_VISITS = 'onSelectToothPatientVisits';

/**
 * @description Идентификатор цели, добавить услуги в заказ-наряд.
 * @type {string}
 */
export const GOAL_ADD_SERVICES_TO_CUSTOM_ORDER_PATIENT_VISITS = 'onAddServicesToCustomOrderPatientVisits';

/**
 * @description Идентификатор цели, печать форма 043/у.
 * @type {string}
 */
export const GOAL_PRINT_043Y_PATIENT_VISITS = 'onPrint043YPatientVisits';

/**
 * @description Идентификатор цели нажатия добавления перерыва сотрудника по ФИО.
 * @type {string}
 */
export const GOAL_CLICK_EMPLOYEE_ADD_BREAK_BY_FIO = 'onAddEmployeeBreakByFio';

/**
 * @description Идентификатор цели нажатия добавления перерыва сотрудника.
 * @type {string}
 */
export const GOAL_CLICK_EMPLOYEE_ADD_BREAK = 'onAddEmployeeBreak';

/**
 * @description Обработчики целей.
 * @type {any}
 */
const handlers = {
  [GOAL_PRINT_043Y_PATIENT_VISITS]() {
    this.$metrika.reachGoal('pechat043');
  },
  [GOAL_ADD_SERVICES_TO_CUSTOM_ORDER_PATIENT_VISITS]() {
    this.$metrika.reachGoal('zakaz_nariad');
  },
  [GOAL_SELECT_TOOTH_PATIENT_VISITS]() {
    this.$metrika.reachGoal('vizit_zub_uslugi');
  },
  [GOAL_TO_INVOICE_PATIENT_VISITS]() {
    this.$metrika.reachGoal('vizit_kschety');
  },
  [GOAL_ATTACH_FILE_PATIENT_VISITS]() {
    this.$metrika.reachGoal('vizit_fail');
  },
  [GOAL_SAVE_PROTOCOL_AS_TEMPLATE_PATIENT_VISITS]() {
    this.$metrika.reachGoal('vizit_saveasshablon');
  },
  [GOAL_TO_ANOTHER_VISIT_PATIENT_VISITS]() {
    this.$metrika.reachGoal('vizit_perehod');
  },
  [GOAL_PRINT_INVOICE_RECEIPTS_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_pechat');
  },
  [GOAL_CHANGE_PAY_MODE_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_redaktirovat');
  },
  [GOAL_CLICK_MULTI_PAY_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('smeshanaya_oplata');
  },
  [GOAL_SELECT_CASH_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('vibor_cash');
  },
  [GOAL_TO_VISIT_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_vizit');
  },
  [GOAL_PRINT_ACT_INVOICE_ACT_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('akt');
  },
  [GOAL_CHANGE_SETTING_TABLE_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_nastroika');
  },
  [GOAL_INPUT_COMMENT_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_komment');
  },
  [GOAL_FILTERS_PATIENT_INVOICE]() {
    this.$metrika.reachGoal('schet_filtr');
  },
  [GOAL_PRINT_ACT_MUTUAL_SETTLEMENTS_PATIENT_INVOICES]() {
    this.$metrika.reachGoal('akt_sverki');
  },
  [GOAL_CLICK_PATIENT_DETAILING_ADVANCE_PATIENT_INVOICES]() {
    this.$metrika.reachGoal('detalizacia_avansa');
  },
  [GOAL_WRITE_OFF_ADVANCE_PATIENT_INVOICES]() {
    this.$metrika.reachGoal('spisat_avanc');
  },
  [GOAL_TOP_UP_ADVANCE_PATIENT_INVOICES]() {
    this.$metrika.reachGoal('popolnit_avanc');
  },
  [GOAL_SEARCH_BY_DOCUMENTS_PATIENT_DOCUMENTS]() {
    this.$metrika.reachGoal('dokument_poisk');
  },
  [GOAL_CLICK_REGISTRY_REFERENCES_PATIENT_DOCUMENTS]() {
    this.$metrika.reachGoal('dokument_reestr');
  },
  [GOAL_CLICK_DOCUMENT_REFERENCE_ELECTRON_TAX_PATIENT_DOCUMENTS]() {
    this.$metrika.reachGoal('dokument_spravka_XML');
  },
  [GOAL_CLICK_DOCUMENT_REFERENCE_TEXT_TAX_PATIENT_DOCUMENTS]() {
    this.$metrika.reachGoal('dokument_spravka_tekst');
  },
  [GOAL_ADD_DOCUMENT_PATIENT_DOCUMENTS]() {
    this.$metrika.reachGoal('dobavit_dokument');
  },
  [GOAL_UPLOAD_PATIENT_SNAPSHOTS]() {
    this.$metrika.reachGoal('snimok');
  },
  [GOAL_ADD_APPOINTMENT_PATIENT_APPOINTMENTS]() {
    this.$metrika.reachGoal('Istoria_zapis');
  },
  [GOAL_DOWNLOAD_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_skachat');
  },
  [GOAL_PRINT_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_pechat');
  },
  [GOAL_ADD_STAGE_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_newetap');
  },
  [GOAL_APPLY_TEMPLATE_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_shablon');
  },
  [GOAL_CHANGE_RESPONSIBLE_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_kurator');
  },
  [GOAL_CHANGE_VALIDITY_PERIOD_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_period');
  },
  [GOAL_CREATE_PATIENT_PLAN]() {
    this.$metrika.reachGoal('NEW_PL');
  },
  [GOAL_CLICK_FILTER_PATIENT_PLAN]() {
    this.$metrika.reachGoal('PL_filtr');
  },
  [GOAL_PRINT_HEALTH_QUESTIONNAIRE_QUESTIONS]() {
    this.$metrika.reachGoal('anketa_pechat');
  },
  [GOAL_ADD_HEALTH_QUESTIONNAIRE_QUESTIONS]() {
    this.$metrika.reachGoal('new_vopros');
  },
  [GOAL_CLICK_DO_NOT_CALL]() {
    this.$metrika.reachGoal('nezonit');
  },
  [GOAL_MAKE_MAIN_PATIENT_PHONE]() {
    this.$metrika.reachGoal('osnovnoynomer');
  },
  [GOAL_ADD_SECOND_PATIENT_PHONE]() {
    this.$metrika.reachGoal('newtelefon');
  },
  [GOAL_ADD_PATIENT_LABELS]() {
    this.$metrika.reachGoal('metka');
  },
  [GOAL_DOWNLOAD_PATIENT]() {
    this.$metrika.reachGoal('skachat_onepatient');
  },
  [GOAL_CLICK_PATIENT_VISIT_DATE]() {
    this.$metrika.reachGoal('pacient_data_info');
  },
  [GOAL_CHANGE_PATIENT_COLUMN_SETTINGS]() {
    this.$metrika.reachGoal('pacient_setting');
  },
  [GOAL_CREATE_NEW_PATIENT]() {
    this.$metrika.reachGoal('new_pacient');
  },
  [GOAL_COPY_PATIENT]() {
    this.$metrika.reachGoal('copy_pacient');
  },
  [GOAL_CLICK_MY_PROFILE]() {
    this.$metrika.reachGoal('profil');
  },
  [GOAL_COPY_APPOINTMENT]() {
    this.$metrika.reachGoal('copyvizit');
  },
  [GOAL_CLICK_TODAY]() {
    this.$metrika.reachGoal('today');
  },
  [GOAL_CLICK_TOMORROW]() {
    this.$metrika.reachGoal('zavtra');
  },
  [GOAL_CLICK_NEAREST_UNCONFIRMED_APPOINTMENT]() {
    this.$metrika.reachGoal('obzvon');
  },
  [GOAL_VIEW_WAITING_LIST]() {
    this.$metrika.reachGoal('listozidan_spisok');
  },
  [GOAL_SUCCESS_ADD_PATIENT_WAITING_LIST]() {
    this.$metrika.reachGoal('listozidania_new');
  },
  [GOAL_ACCOUNTING_TIME]() {
    this.$metrika.reachGoal('uchet_vremeni');
  },
  [GOAL_CLICK_BUTTON_FREE_DOCTOR]() {
    this.$metrika.reachGoal('svob_vrach');
  },
  [GOAL_COMPLETED_CLICK_ONLINE_BUTTON]() {
    this.$metrika.reachGoal('oplata_onlain');
  },
  [GOAL_COMPLETED_CLICK_DOWNLOAD_INVOICE]() {
    this.$metrika.reachGoal('oplata_schet');
  },
  [GOAL_COMPLETED_REGISTRATION]() {
    this.$metrika.reachGoal('uspeh');
  },
  [GOAL_CHANGE_APPOINTMENT_TIMELINE_STEP]() {
    this.$metrika.reachGoal('shag');
  },
  [GOAL_CHANGE_PATIENT_BIRTH_DATE_FILTER]() {
    this.$metrika.reachGoal('filtr_DR');
  },
  [GOAL_CHANGE_PATIENT_BIRTH_DATE_MONTH_FILTER]() {
    this.$metrika.reachGoal('strelka_month');
  },
  [GOAL_DOWNLOAD_PATIENTS_LIST]() {
    this.$metrika.reachGoal('baza_patients');
  },
  [GOAL_VIEW_UPDATES_APP]() {
    this.$metrika.reachGoal('obnovlenia');
  },
  [GOAL_CLICK_HELP_BUTTON]() {
    this.$metrika.reachGoal('pomoch');
  },
  [GOAL_PRINT_MEDCART_A5]() {
    this.$metrika.reachGoal('medcart_a5');
  },
  [GOAL_SWITCH_DETAIL_DENTAL_FORMULA]() {
    this.$metrika.reachGoal('detail_formula');
  },
  [GOAL_APPLY_DIARY_TEMPLATE]() {
    this.$metrika.reachGoal('vizit_shablon_protocol');
  },
  [GOAL_ADD_INVOICE]() {
    this.$metrika.reachGoal('dobavit_schet');
  },
  [GOAL_APPLY_TREATMENT_PLAN_TEMPLATE]() {
    this.$metrika.reachGoal('shablon_uslug');
  },
  [GOAL_PRINT_DOCUMENT_PROTOCOL]() {
    this.$metrika.reachGoal('pechat_protocol');
  },
  [GOAL_DOWNLOAD_DOCUMENT_PROTOCOL]() {
    this.$metrika.reachGoal('skachat_protocol');
  },
  [GOAL_SELECT_TEETH_DIARY]() {
    this.$metrika.reachGoal('protocol_zub');
  },
  [GOAL_ADDING_TREATMENT_PLAN_SERVICE]() {
    this.$metrika.reachGoal('uslugi_PL');
  },
  [GOAL_CLICK_DOCTOR_FIO_ON_SCHEDULE]() {
    this.$metrika.reachGoal('click_fio');
  },
  [GOAL_CLICK_HOW_TO_SET_UP_BUTTON]() {
    this.$metrika.reachGoal('kak_nastroit');
  },
  [GOAL_COPY_EMPLOYEES_WORK_SCHEDULE]() {
    this.$metrika.reachGoal('prodlit_grafik');
  },
  [GOAL_INPUT_COMPLAINT_VISIT_SERVICE_TABLE]() {
    this.$metrika.reachGoal('garant');
  },
  [GOAL_CLICK_EMPLOYEE_ADD_BREAK_BY_FIO]() {
    this.$metrika.reachGoal('newpereriv_fiovracha');
  },
  [GOAL_CLICK_EMPLOYEE_ADD_BREAK]() {
    this.$metrika.reachGoal('newpereriv');
  },
};

/**
 * @description Плагин метрики.
 * @constructor
 * @type {VuePlugin}
 */
export default function VueMetric(logger = console) {
  /**
   * @inheritDoc
   */
  this.install = (Vue) => {
    Vue.use(VueYandexMetrika, yandexMetrikaParams);
    Object.defineProperty(Vue.prototype, '$goal', {
      value(trigger, ...args) {
        const handler = (this.$metrika && handlers[trigger]) || (
          () => logger.warn('uncaught goal of metric:', trigger, ...args)
        );
        handler.bind(this, ...args)();
      },
    });
  };
}
